import { GET_SHARED_PLAN_TERMINALS_BY_ID } from "./../graphql/queries/getSharedPlanTerminalsById"
import { useQuery } from "@apollo/client"

export const useSharedPlanTerminalsById = (apiPlanId: number) => {
  const { data, error, loading, refetch } = useQuery(GET_SHARED_PLAN_TERMINALS_BY_ID, {
    variables: {
      apiPlanId: apiPlanId,
    },
  })
  return {
    sharedPlanTerminals: data?.sharedPlan,
    sharedPlanTerminalsError: error,
    sharedPlanTerminalsLoading: loading,
    refetch,
  }
}
